module.exports = new __parcel__URL__("training_tab_inactive.6edfbf50.png").toString();